import { render, staticRenderFns } from "./ConceptDetails.vue?vue&type=template&id=f3da55dc&scoped=true"
import script from "./ConceptDetails.vue?vue&type=script&lang=ts"
export * from "./ConceptDetails.vue?vue&type=script&lang=ts"
import style0 from "./ConceptDetails.vue?vue&type=style&index=0&id=f3da55dc&lang=scss"
import style1 from "./ConceptDetails.vue?vue&type=style&index=1&id=f3da55dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3da55dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3da55dc')) {
      api.createRecord('f3da55dc', component.options)
    } else {
      api.reload('f3da55dc', component.options)
    }
    module.hot.accept("./ConceptDetails.vue?vue&type=template&id=f3da55dc&scoped=true", function () {
      api.rerender('f3da55dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/concepts/components/ConceptDetails.vue"
export default component.exports